export function getFilterBookmarks(state) {
  return state.filterBookmarks;
}

export function getFilterBookmarksPosition(state) {
  return state.filterBookmarksPosition;
}



// WEBPACK FOOTER //
// ./src/app/bookmark/store/getters.js